import type { NodeGroupOption } from '@lighthouse/shared'
import {
    aiNodeTypeOptions,
    aLiYunNodeTypeOptions,
    dataNodeTypeOptions,
    dingNodeTypeOptions,
    enterpriseWeChatNodeTypeOptions,
    flowControlNodeTypeOptions,
    noticeNodeTypeOptions,
    operatorNodeTypeOptions,
    searchApiNodeTypeOptions,
    stripeNodeTypeOptions,
    tencentEmailNodeTypeOptions,
    wangYiEmailNodeTypeOptions,
    wxAccountNodeTypeOptions,
    wxMerchantNodeTypeOptions,
    wxMiniProgramNodeTypeOptions
} from '@lighthouse/shared'

export const nodeList: NodeGroupOption[] = [
    {
        label: 'AI',
        children: aiNodeTypeOptions
    },
    {
        label: '数据处理',
        children: dataNodeTypeOptions
    },
    {
        label: '通知',
        children: noticeNodeTypeOptions
    },
    {
        label: '流程控制',
        children: flowControlNodeTypeOptions
    },
    {
        label: '操作',
        children: operatorNodeTypeOptions
    }
]

export const unitList: NodeGroupOption[] = [
    {
        label: '微信公众号',
        unitType: 'WECHAT_OFFICIAL_ACCOUNT',
        children: wxAccountNodeTypeOptions
    },
    {
        label: '微信商户号',
        unitType: 'WECHAT_PAY',
        children: wxMerchantNodeTypeOptions
    },
    {
        label: '微信小程序',
        unitType: 'WECHAT_MINI_PROGRAM',
        children: wxMiniProgramNodeTypeOptions
    },
    {
        label: 'Search API',
        unitType: 'SEARCH_API',
        children: searchApiNodeTypeOptions
    },
    {
        label: '钉钉',
        unitType: 'DING_TALK_ROBOT',
        children: dingNodeTypeOptions
    },
    {
        label: '企业微信',
        unitType: 'WE_COM_ROBOT',
        children: enterpriseWeChatNodeTypeOptions
    },
    {
        label: '阿里云',
        unitType: 'ALIYUN_SMS',
        children: aLiYunNodeTypeOptions
    },
    {
        label: '腾讯企业邮箱',
        unitType: 'WE_COM_MAIL',
        children: tencentEmailNodeTypeOptions
    },
    {
        label: '126网易免费邮',
        unitType: 'NET_EASE_126_MAIL',
        children: wangYiEmailNodeTypeOptions
    },
    {
        label: 'Stripe',
        unitType: 'STRIPE',
        children: stripeNodeTypeOptions
    }
]
